// Constructor
function Screensaver(app) {
	this.app = app;
	this.types = [{
		name: "part1",
		rowCount: 5,
		partsCountPerRow: 7,
		offsetX: 150,
		offsetY: 150
	}, {
		name: "part2",
		rowCount: 5,
		partsCountPerRow: 5,
		offsetX: 190,
		offsetY: 80
	}, {
		name: "part3",
		rowCount: 5,
		partsCountPerRow: 7,
		offsetX: 110,
		offsetY: 55,
	}, {
		name: "part4",
		rowCount: 6,
		partsCountPerRow: 7,
		offsetX: -40,
		offsetY: -10
	}, {
		name: "part5",
		rowCount: 6,
		partsCountPerRow: 7,
		offsetX: 20,
		offsetY: 0
	}];

	this.init();
}


Screensaver.prototype.init = function () {

	var $el = $("#screensaver");
	var variant = 0;

	for (var i = 0; i < this.types.length; i++) {
		var type = this.types[i];

		for (var j = 0; j < type["rowCount"]; j++) {
			var $rowEl = $('<div class="row" />');
			for (var k = 0; k < type["partsCountPerRow"]; k++) {
				var $partEl = $('<div class="part ' + type["name"] + '"><div class="animation"></div></div>');
				var zebra = (j % 2) * 100
				var left = 1920 / type["partsCountPerRow"] * k + type["offsetX"] + zebra;
				var top = 1080 / type["rowCount"] * j + type["offsetY"];
				$partEl.css("top", top + "px").css("left", left + "px").addClass("variant-" + (variant + 1));
				$rowEl.append($partEl);
				variant = ((variant + 1) % 6)
			}

			$el.append($rowEl);
		}
	}
}


Screensaver.prototype.show = function () {
	console.log("show screensaver");
};


Screensaver.prototype.hide = function () {
	console.log("hide screensaver");
};


// Expose GMOs
window.Screensaver = Screensaver;
